/* Rorilio · PDP Scrub Reset : galerie, packs (une variante, le pack règle la quantité ; codes et cadeau posés par rorilio-offers.js),
   stock et minuteur (minuit America/Mexico_City, redémarre chaque jour, barre 70 à 95 % comme la source), accordéons, carrousels, compteurs, compléments, avis. */
(function () {
  if (window.__scrPdp) return; window.__scrPdp = true;
  function $a(s, r) { return [].slice.call((r || document).querySelectorAll(s)); }
  function ready(fn) { if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn); else fn(); }
  function two(n) { return (n < 10 ? '0' : '') + n; }
  function secsIn(tz) {
    try {
      var p = new Intl.DateTimeFormat('en-US', { timeZone: tz, hour12: false, hour: '2-digit', minute: '2-digit', second: '2-digit' }).formatToParts(new Date());
      var o = {}; p.forEach(function (x) { o[x.type] = x.value; });
      return (parseInt(o.hour, 10) % 24) * 3600 + parseInt(o.minute, 10) * 60 + parseInt(o.second, 10);
    } catch (e) { var d = new Date(); return d.getHours() * 3600 + d.getMinutes() * 60 + d.getSeconds(); }
  }
  function addAndOpen(items, btn, onfail) {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/', RO = window.RorilioOffers;
    btn.classList.add('is-busy');
    return fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok || j.status) throw new Error(j.description || j.message || 'Error'); return j; }); })
      .then(function () { return RO ? RO.reconcile(true) : null; })
      .then(function (st) { btn.classList.remove('is-busy'); if (st) delete st._silent; if (!RO || !st || !st.sections || !RO.open(st)) location.href = root + 'cart'; })
      .catch(function (e) { btn.classList.remove('is-busy'); onfail(e); });
  }
  ready(function () {
    /* Stock + minuteur */
    $a('[data-scr-stock]').forEach(function (el) {
      var tz = el.getAttribute('data-tz') || 'America/Mexico_City', out = el.querySelector('[data-time]'), fill = el.querySelector('[data-fill]'), pc = el.querySelector('[data-pct]'), lb = el.querySelector('[data-label]'), bar = el.querySelector('[role=progressbar]');
      function tick() {
        var s = secsIn(tz), left = 86400 - s; if (left >= 86400) left = 0;
        out.textContent = two(Math.floor(left / 3600)) + ':' + two(Math.floor((left % 3600) / 60)) + ':' + two(left % 60);
        var p = Math.min(95, Math.max(70, Math.round((70 + (s / 86400) * 25) * 10) / 10));
        fill.style.width = p + '%'; pc.textContent = Math.floor(p); bar.setAttribute('aria-valuenow', Math.round(p));
        var low = p >= 90; el.classList.toggle('is-low', low); lb.textContent = el.getAttribute(low ? 'data-low' : 'data-ok');
      }
      tick(); setInterval(tick, 1000);
    });
    /* Galerie */
    $a('[data-scr-gal]').forEach(function (g) {
      var sl = g.querySelector('.scr-gal__slides'), th = $a('.scr-gal__thumb', g), n = $a('.scr-gal__slide', g).length, cur = 0, tb = g.querySelector('.scr-gal__thumbs');
      function mark(i) { cur = i; th.forEach(function (t, k) { t.classList.toggle('is-on', k === i); }); var t = th[i]; if (t && tb) tb.scrollTo({ left: t.offsetLeft - tb.clientWidth / 2 + t.clientWidth / 2, behavior: 'smooth' }); }
      function go(i) { i = (i + n) % n; sl.scrollTo({ left: sl.clientWidth * i, behavior: 'smooth' }); mark(i); }
      th.forEach(function (t, i) { t.addEventListener('click', function () { go(i); }); });
      $a('.scr-gal__nav', g).forEach(function (b) { b.addEventListener('click', function () { go(cur + parseInt(b.getAttribute('data-dir'), 10)); }); });
      var w; sl.addEventListener('scroll', function () { clearTimeout(w); w = setTimeout(function () { var i = Math.round(sl.scrollLeft / (sl.clientWidth || 1)); if (i !== cur) mark(i); }, 90); }, { passive: true });
    });
    /* Achat */
    $a('[data-scr-buy]').forEach(function (b) {
      var vid = Number(b.getAttribute('data-variant')), packs = $a('[data-pack]', b), sel = b.querySelector('[data-pack].is-on') || packs[0], atc = b.querySelector('[data-atc]'), err = b.querySelector('[data-err]');
      function paint() { packs.forEach(function (p) { var on = p === sel; p.classList.toggle('is-on', on); p.setAttribute('aria-checked', on ? 'true' : 'false'); }); }
      packs.forEach(function (p) {
        p.addEventListener('click', function () { sel = p; paint(); });
        p.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); sel = p; paint(); } });
      });
      atc.addEventListener('click', function () {
        if (err) err.hidden = true;
        addAndOpen([{ id: vid, quantity: parseInt(sel.getAttribute('data-qty'), 10) || 1 }], atc, function (e) { if (err) { err.textContent = e.message || 'Error'; err.hidden = false; } });
      });
      paint();
    });
    /* Compléments */
    $a('[data-up-add]').forEach(function (btn) {
      btn.addEventListener('click', function () { addAndOpen([{ id: Number(btn.getAttribute('data-up-add')), quantity: 1 }], btn, function (e) { btn.textContent = e.message || 'Error'; }); });
    });
    /* Accordéons */
    $a('[data-scr-acc]').forEach(function (list) {
      list.addEventListener('click', function (e) {
        var q = e.target.closest('[data-q]'); if (!q || !list.contains(q)) return;
        var it = q.parentElement, open = it.classList.contains('is-open');
        it.classList.toggle('is-open', !open); q.setAttribute('aria-expanded', open ? 'false' : 'true');
        var a = it.querySelector('[data-a]'); if (a) a.hidden = open;
      });
    });
    /* Carrousels */
    $a('[data-scr-car]').forEach(function (c) {
      var tr = c.querySelector('.scr-car__tr'), p = c.querySelector('[data-dir="-1"]'), n = c.querySelector('[data-dir="1"]');
      function step() { var k = tr.children; return k.length > 1 ? k[1].offsetLeft - k[0].offsetLeft : tr.clientWidth; }
      function upd() { var max = tr.scrollWidth - tr.clientWidth - 2; p.hidden = tr.scrollLeft <= 2; n.hidden = tr.scrollLeft >= max; }
      p.addEventListener('click', function () { tr.scrollBy({ left: -step(), behavior: 'smooth' }); });
      n.addEventListener('click', function () { tr.scrollBy({ left: step(), behavior: 'smooth' }); });
      tr.addEventListener('scroll', upd, { passive: true }); window.addEventListener('resize', upd); upd();
    });
    /* Témoignages : lire plus */
    $a('[data-more]').forEach(function (b) {
      var q = b.parentElement.querySelector('.scr-tc__q'), more = b.textContent;
      b.addEventListener('click', function () { var c = q.classList.toggle('is-clamp'); b.textContent = c ? more : b.getAttribute('data-less'); });
    });
    /* Compteurs */
    var nums = $a('[data-scr-count]');
    if (nums.length && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) { es.forEach(function (e) {
        if (!e.isIntersecting) return; io.unobserve(e.target);
        var el = e.target, to = parseInt(el.getAttribute('data-scr-count'), 10), t0 = null;
        function f(ts) { if (!t0) t0 = ts; var k = Math.min((ts - t0) / 1300, 1); el.textContent = Math.round(to * (1 - Math.pow(1 - k, 3))); if (k < 1) requestAnimationFrame(f); }
        requestAnimationFrame(f);
      }); }, { threshold: .4 });
      nums.forEach(function (n) { io.observe(n); });
    }
    /* Avis */
    $a('[data-scr-rev]').forEach(function (r) {
      var list = r.querySelector('[data-rev-list]'), pg = r.querySelector('[data-rev-pg]'), strip = r.querySelector('[data-rev-strip]'), per = +r.getAttribute('data-per') || 5, sortEl = r.querySelector('[data-rev-sort]');
      var all = [], view = [], page = 1, forL = r.getAttribute('data-for'), name = r.getAttribute('data-name');
      var STAR = '<svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2l2.9 6.9 7.1.6-5.4 4.7 1.7 7-6.3-3.9-6.3 3.9 1.7-7L2 9.5l7.1-.6z"/></svg>';
      function esc(t) { var d = document.createElement('div'); d.textContent = t; return d.innerHTML; }
      function card(o) {
        var st = ''; for (var k = 0; k < 5; k++) st += '<span class="' + (k < o.s ? '' : 'is-off') + '">' + STAR + '</span>';
        return '<article class="scr-rc"><div class="scr-rc__st">' + st + '</div><div class="scr-rc__who"><span class="scr-rc__av">' + esc((o.n || '?').charAt(0).toUpperCase()) + '</span><span><b>' + esc(o.n) + '</b><small>' + esc(o.d) + '</small></span></div><p>' + esc(o.t) + '</p>'
          + ((o.p && o.p.length) ? '<div class="scr-rc__ph">' + o.p.map(function (u) { return '<img src="' + u + '&width=320" data-full="' + u + '&width=1200" alt="" loading="lazy">'; }).join('') + '</div>' : '')
          + (o.b ? '<div class="scr-rc__for"><span>' + esc(forL) + '</span> <u>' + esc(name) + '</u></div>' : '') + '</article>';
      }
      function pager() {
        var total = Math.ceil(view.length / per), h = '', set = {}, i;
        if (total < 2) { pg.innerHTML = ''; return; }
        [1, 2, 3, 4, page - 1, page, page + 1, total].forEach(function (x) { if (x >= 1 && x <= total) set[x] = 1; });
        var ks = Object.keys(set).map(Number).sort(function (a, b) { return a - b; }), last = 0;
        h += '<button type="button" data-p="' + (page - 1) + '"' + (page === 1 ? ' disabled' : '') + ' aria-label="Anterior">&#8249;</button>';
        for (i = 0; i < ks.length; i++) { if (ks[i] - last > 1) h += '<span>...</span>'; h += '<button type="button" data-p="' + ks[i] + '"' + (ks[i] === page ? ' class="is-on" aria-current="page"' : '') + '>' + ks[i] + '</button>'; last = ks[i]; }
        h += '<button type="button" data-p="' + (page + 1) + '"' + (page === total ? ' disabled' : '') + ' aria-label="Siguiente">&#8250;</button>';
        pg.innerHTML = h;
      }
      function draw(scroll) {
        list.innerHTML = view.slice((page - 1) * per, page * per).map(card).join(''); pager();
        if (scroll) r.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
      function sort() {
        var s = sortEl.value, v = all.slice();
        function dt(o) { return o.d.split('/').reverse().join(''); }
        if (s === 'only') v = v.filter(function (o) { return o.p && o.p.length; });
        v.sort(function (a, b) {
          var da = dt(a), db = dt(b), rec = db < da ? -1 : db > da ? 1 : a.i - b.i;
          if (s === 'high') return b.s - a.s || rec;
          if (s === 'low') return a.s - b.s || rec;
          if (s === 'photo') return ((b.p || []).length > 0) - ((a.p || []).length > 0) || rec;
          return rec;
        });
        view = v; page = 1; draw();
      }
      sortEl.addEventListener('change', sort);
      var po = r.querySelector('[data-photo-only]'); if (po) po.addEventListener('click', function () { sortEl.value = sortEl.value === 'only' ? 'high' : 'only'; po.classList.toggle('is-on', sortEl.value === 'only'); sort(); });
      pg.addEventListener('click', function (e) { var b = e.target.closest('[data-p]'); if (!b || b.disabled) return; page = +b.getAttribute('data-p'); draw(true); });
      r.addEventListener('click', function (e) {
        var im = e.target.closest('.scr-rc__ph img,.scr-rev__strip img'); if (!im) return;
        var lb = document.createElement('div'); lb.className = 'scr-rev__lb'; lb.innerHTML = '<img src="' + im.getAttribute('data-full') + '" alt="">'; lb.addEventListener('click', function () { lb.remove(); }); r.appendChild(lb);
      });
      fetch(r.getAttribute('data-src')).then(function (x) { return x.json(); }).then(function (d) {
        d.forEach(function (o, i) { o.i = i; }); all = d;
        strip.innerHTML = d.filter(function (o) { return o.p && o.p.length; }).map(function (o) { return o.p.map(function (u) { return '<img src="' + u + '&width=200" data-full="' + u + '&width=1200" alt="" loading="lazy" width="100" height="100">'; }).join(''); }).join('');
        sort();
      });
    });
  });
})();
